import React from 'react';
import { Form, Input, message, Modal } from 'antd';
import { KnowledgeListVo, saveKnowledge, updateKnowledge } from '@/api/knowledge';

export interface EditKnowledgeProp {
  data?: KnowledgeListVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditKnowledge = ({ data, isEdit, updateFn, onCancel }: EditKnowledgeProp) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    // 这里可以添加提交逻辑
    form.validateFields().then(values => {
      const api = isEdit ? updateKnowledge : saveKnowledge;
      api({ ...values, id: data?.id }).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal title={isEdit ? '编辑知识库' : '新增知识库'} open={true} onCancel={onCancel} onOk={onFinish} maskClosable={false}>
      <Form form={form} layout="vertical" initialValues={data}>
        <Form.Item name="title" label="标题" rules={[{ required: true, message: '请输入标题' }]}>
          <Input placeholder="请输入" />
        </Form.Item>
        <Form.Item name="content" label="文本内容" rules={[{ required: true, message: '请输入内容' }]}>
          <Input.TextArea rows={6} autoSize={false} placeholder="请输入" />
        </Form.Item>
        <Form.Item name="description" label="描述" rules={[{ required: true, message: '请输入描述' }]}>
          <Input.TextArea rows={2} autoSize={false} placeholder="请输入" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditKnowledge;
